import { useRef, useState } from "react";
import "../styles/navbar.css";

export default function Navbar({ setLang, lang, t }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButton = useRef(null);
  const closeMenu = () => setMenuOpen(false);
  const links = [
    { id: "services", label: t.services },
    { id: "about", label: t.about },
    { id: "coverage", label: t.coverage.eyebrow },
  ];

  return (
    <header className="site-header" onKeyDown={event => {
      if (event.key === "Escape" && menuOpen) {
        closeMenu();
        menuButton.current?.focus();
      }
    }}>
      <div className="site-header-inner">
        <a className="site-brand" href="#hero" onClick={closeMenu} aria-label={lang === "pl" ? "Eastlog — strona główna" : "Eastlog — home"}>
          <span className="site-brand-original">Eastlog sp. z o.o. <span>Poland</span></span>
        </a>
        <div className="site-header-controls">
          <div className="site-language" role="group" aria-label={lang === "pl" ? "Język strony" : "Site language"}>
            <button type="button" aria-pressed={lang === "pl"} onClick={() => setLang("pl")}>PL</button>
            <button type="button" aria-pressed={lang === "en"} onClick={() => setLang("en")}>EN</button>
          </div>
          <button ref={menuButton} className="site-menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="site-navigation" aria-label={lang === "pl" ? (menuOpen ? "Zamknij menu" : "Otwórz menu") : (menuOpen ? "Close menu" : "Open menu")} onClick={() => setMenuOpen(open => !open)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d={menuOpen ? "m6 6 12 12M6 18 18 6" : "M4 7h16M4 12h16M4 17h16"} /></svg>
          </button>
        </div>
        <nav id="site-navigation" className={`site-navigation${menuOpen ? " is-open" : ""}`} aria-label={lang === "pl" ? "Menu główne" : "Main navigation"}>
          {links.map(link => <a key={link.id} href={`#${link.id}`} onClick={closeMenu}>{link.label}</a>)}
          <a className="site-contact-link" href="#contact" onClick={closeMenu}>{t.contact}<span aria-hidden="true">↗</span></a>
        </nav>
      </div>
    </header>
  );
}
